export { WithIconsAndDescriptionsVariation as default } from './WithIconsAndDescriptionsVariation';
